if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.viewer) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails?.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener(
              'click',
              this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)
            );
        });

        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails?.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const viewer = this.elements.viewer;
        const thumbnails = this.elements.thumbnails;

        // ✅ GUARDAMOS POSICIÓN ACTUAL
        const viewerScrollLeft = viewer.scrollLeft;
        const thumbsScrollLeft = thumbnails?.slider?.scrollLeft;

        const activeMedia =
          viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        viewer.querySelectorAll('[data-media-id]').forEach((el) => {
          el.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia &&
            activeMedia.parentElement.prepend(activeMedia);

          if (thumbnails) {
            const activeThumbnail = thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail?.parentElement?.prepend(activeThumbnail);
          }

          // ❌ NO resetPages()
        }

        this.playActiveMedia(activeMedia);

        if (thumbnails) {
          const activeThumbnail = thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
          this.announceLiveRegion(activeMedia, activeThumbnail?.dataset.mediaPosition);
        }

        // ✅ RESTAURAMOS POSICIÓN (CLAVE)
        requestAnimationFrame(() => {
          viewer.scrollLeft = viewerScrollLeft;
          if (thumbnails?.slider && typeof thumbsScrollLeft === 'number') {
            thumbnails.slider.scrollLeft = thumbsScrollLeft;
          }
        });
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((el) => el.removeAttribute('aria-current'));

        thumbnail.querySelector('button').setAttribute('aria-current', true);

        // ❌ NO hacer scroll automático
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image || !this.elements.liveRegion) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }
    }
  );
}
